import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Header } from "@aptsi-types";
import { MatDialog } from "@angular/material/dialog";
import { Subject } from "rxjs";
import { debounceTime, distinctUntilChanged } from "rxjs/operators";

import { KeycloakStateService } from "src/app/core/service/utility.service";
import { EnvironmentService } from "src/app/core/service/environment.service";

import { ErrorDialogComponent } from "src/app/shared/dialogs/error-dialog/error-dialog.component";

import { MissingAccessFlowDialogComponent } from "../missing-access-flow-dialog/missing-access-flow-dialog.component";
import { SmartContractAccessFlowService } from "../smart-contract-access-flow.service";
import { SmartContractAccessFlow } from "@aptsi-types";
import { SuccessDialogComponent } from "../../shared/dialogs/success-dialog/success-dialog.component";

@Component({
  selector: "app-access-flow-search",
  templateUrl: "./smart-contract-access-flow-search.component.html",
  styleUrls: ["./smart-contract-access-flow-search.component.scss"],
})
export class SmartContractAccessFlowSearchComponent implements OnInit {

  // ─── Pagination ───────────────────────────────────────────────
  currentPage = 1;
  itemsPerPage = 7;
  totalPages = 1;

  // ─── Search ──────────────────────────────────────────────────
  searchText: string = "";
  filterByHeader: string = "all";
  issearch: boolean = false;
  searchTextChanged = new Subject<string>();

  // ─── Data ─────────────────────────────────────────────────────
  contracts: SmartContractAccessFlow[] = [];
  filteredData: SmartContractAccessFlow[] = [];
  searchedData: SmartContractAccessFlow[] = [];
  organizationId: string | null= '';

  // ─── Headers ──────────────────────────────────────────────────
  headers: Header[] = [
    {
      name: "Chaincode Id",
      property: "chaincodeId",
      showInDropdown: true,
      description: "Unique identifier for chaincode",
    },
    {
      name: "Chaincode Name",
      property: "chaincodeName",
      showInDropdown: true,
      description: "Name of chaincode",
    },
    {
      name: "Channel",
      property: "channelName",
      showInDropdown: true,
      description: "Channel name",
    },
    {
      name: "Status",
      property: "status",
      showInDropdown: true,
      description: "Deployment status",
    },
    {
      name: "Access Flow",
      property: "accessFlowName",
      showInDropdown: true,
      description: "Access flow name",
    },
    {
      name: "Active",
      property: "active",
      showInDropdown: false,
      description: ""
    }
  ];

  buttonConfig = {
    update: true,
    delete: false,
    capture: false,
  };

  // ─── Constructor ─────────────────────────────────────────────
  constructor(
    private router: Router,
    private smartContractAccessFlowService: SmartContractAccessFlowService,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    private keycloakStateService: KeycloakStateService,
    public environmentService: EnvironmentService
  ) { }

  // ─── Lifecycle ───────────────────────────────────────────────
  async ngOnInit(): Promise<void> {
    this.organizationId = this.keycloakStateService.getOrganizationId();
    await this.fetchChaincodeAccessFlows();

  }

  // ─── Fetch Data ──────────────────────────────────────────────
  async fetchChaincodeAccessFlows(): Promise<void> {
    try {
      this.smartContractAccessFlowService
        .getChaincodesWithAccessFlow(this.organizationId).subscribe((res: any[]) => {
            this.contracts = res;
      this.filteredData = this.contracts;

        })
      // this.smartContractAccessFlowService.getChaincodesWithAccessFlow(this.organizationId).subscribe((res: any[]) => {
      // this.contracts = res;
      // this.filteredData = this.contracts;
    } catch (error) {
      console.error("Error fetching chaincode access flows:", error);
    }
  }



  changePage(page: number): void {
    this.currentPage = page;
  }

  // ─── Search ──────────────────────────────────────────────────
  // onSearchTextChange(searchValue: string): void {
  //   this.searchTextChanged.next(searchValue);
  // }

    onSearchTextChange(): void {

    if (!this.searchText) {
      this.issearch = false;
      this.fetchChaincodeAccessFlows();
      return;
    }

    this.issearch = true;

    this.smartContractAccessFlowService
      .searchChaincodesWithAccessFlow(this.currentPage-1, this.searchText, this.filterByHeader, this.organizationId )
      .subscribe((res: any[]) => {
        this.searchedData = res;
      });
  }

  // async searchAccessFlow(): Promise<void> {
  //   if (!this.searchText) {
  //     this.issearch = false;
  //     return;
  //   }

  //   this.issearch = true;
  //   this.currentPage = 1;

  //   const search = this.searchText.toLowerCase();

  //   this.searchedData = this.filteredData.filter((cc) => {

  //     return (
  //       cc.chaincodeName?.toLowerCase().includes(search) ||
  //       cc.chaincodeId?.toLowerCase().includes(search) ||
  //       cc.channelName?.toLowerCase().includes(search) ||
  //       cc.status?.toLowerCase().includes(search) ||
  //       cc.accessFlowName?.toLowerCase().includes(search)
  //     );
  //   });
  // }

  // ─── Actions ─────────────────────────────────────────────────
  handleAction(event: { action: string; rowIndex: number; rowData: any }): void {
    if (event.action === "update") {
      this.updateAccessFlow(event.rowData);
    }
  }

  updateAccessFlow(row: any): void {
    if (row.accessFlowId) {
      this.router.navigate([
        "ada-access/auth-tools/access-flow/update",
        row.accessFlowId
      ]);
    }
  }

  create(): void {
    this.router.navigate(["ada-access/auth-tools/access-flow/create"]);
  }

  back(): void {
    this.router.navigate(["secure-blockchain/auth-tools"]);
  }

  // ─── Generate ────────────────────────────────────────────────
  openGenerateModal() {
    if (!this.organizationId) {
      alert("Organization ID is not available");
      return;
    }

    const dialogRef = this.dialog.open(MissingAccessFlowDialogComponent, {
      width: "800px",
      data: {
        title: "Auto-Generate Access Flow",
        message: "Check whether all assets have accessflow",
        organizationId: this.organizationId,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result?.success) {
        this.openSuccessDialog(true);
        this.fetchChaincodeAccessFlows();
      } else if (result) {
        this.openErrorDialog(result.message);
      }
    });
  }

  // ─── Dialogs ─────────────────────────────────────────────────
  openSuccessDialog(isCreate: boolean): void {
    const dialogRef = this.dialog.open(SuccessDialogComponent, {
      width: "250px",
      data: { isCreate: isCreate, title: "Access Flow" },
    });

    dialogRef.afterClosed().subscribe(() => {
      this.fetchChaincodeAccessFlows();
    });
  }

  openErrorDialog(errorMessage: string): void {
    this.dialog.open(ErrorDialogComponent, {
      width: "250px",
      data: { errorMessage: errorMessage },
    });
  }
}